import PropTypes from 'prop-types';
import React from 'react';
import {FmlxCheckBox} from 'fmlx-common-ui';
import Loading from '../../components/Loading/Loading';

const RoleModalContent = ({
                            isLoading,
                            roles,
                            onRoleCheckedChange,
                          }) => {
  const onRoleCheckedHandler = (e, roleId) => {
    if (onRoleCheckedChange) {
      onRoleCheckedChange(e, roleId);
    }
  };

  return (
    <div className='manage-department-role--role-modal-content'>
      {isLoading ? (<Loading/>) : (
        <>
          {roles.map((role) => {
            return (
              <div key={`manage-department-role--role-modal-contet-${role.id}`}
                   className='manage-department-role--role-modal-content--row1'>
                <div className='manage-department-role--role-modal-content--col1'>{role.roleName}</div>
                <div className='manage-department-role--role-modal-content--col2'>
                  <FmlxCheckBox
                    onChange={(e) => {
                      onRoleCheckedHandler(e, role.id)
                    }}
                    checked={role.checked}
                  />
                </div>
              </div>
            )
          })}
        </>
      )}
    </div>
  );
};

RoleModalContent.propTypes = {
  isLoading: PropTypes.bool,
  roles: PropTypes.array,
  onRoleCheckedChange: PropTypes.func,
};

RoleModalContent.defaultProps = {
  isLoading: false,
  roles: [],
  onRoleCheckedChange: null,
};

export default RoleModalContent;
